import { createFileRoute, redirect } from '@tanstack/react-router'

import { LABELS } from '@/constants/common/message.constants'
import { getDefaultUserMeTenant } from '@/features/auth/models'
import { USER_TYPE } from '@/libs/api/types'

export const Route = createFileRoute('/_protected/$tenantKey/settings/sites')({
  beforeLoad: ({ context: { auth } }) => {
    if (auth.user.type === USER_TYPE.PARTNER) {
      throw redirect({
        to: `/${getDefaultUserMeTenant(auth.user).key}`
      })
    }
  },
  meta: () => [{ title: LABELS.SITE_WITHOUT_AREA }]
})
